<script setup>
import { onBeforeUnmount, onBeforeMount, reactive, ref, onMounted, computed, watch, nextTick } from "vue";
import { useStore } from "vuex";
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import { getTenantIdByName, login, getTenantByWebsite } from "@/api/login";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import Verify from "@/components/Verifition/src/Verify.vue";
import { ElMessage } from "element-plus";
import { getStoredRefreshToken, setRefreshToken, setToken } from "@/utils/auth";
import router from "@/router";
import i18n from "@/language";
import { useI18n } from 'vue-i18n';
// import ArgonCheckbox from "@/components/ArgonCheckbox.vue";

const store = useStore();
const verifyRef = ref();
const checked = ref(false);
const captchaType = 2;
const body = document.getElementsByTagName("body")[0];
const hasReadTerms = ref(false)
const allLoading = ref(false)


// 登录表单数据
const loginForm = reactive({
  password: '',
  userName: '',
  tenantName: "云上田野",
  rememberMe: false
});

// 获取 i18n 当前语言
const { locale } = useI18n();

// 监听语言变化
const currentLanguage = ref(process.env.VUE_APP_DEFAULT_LOCALE || computed(() => store.getters.getLanguage))

// 语言选项
const languageOptions = [
  { value: 'zh-cn', label: '简体中文' },
  { value: 'en-us', label: 'English' },
  { value: 'tr-tr', label: 'Türkçe' },
  { value: 'ru-ru', label: 'русский язык' }
];

// 根据域名，获得租户信息
const getTenantByWebsiteFun = () => {
  allLoading.value = true
  getTenantByWebsiteReq().then(res => {
    allLoading.value = false
  }).catch(err => {
    localStorage.removeItem('TENANT_ID');  
    localStorage.removeItem('TENANT_DIY');  
    allLoading.value = false
  })
}

const getTenantByWebsiteReq = () => {
  const website = location.host
  return new Promise((resolve, reject) => {
    getTenantByWebsite(website).then(res => {
      if (res.data) {
        localStorage.setItem('TENANT_ID', res.data.id);
        if (res.data.diy) {
          localStorage.setItem('TENANT_DIY', JSON.stringify(res.data.diy));
          if (res.data.diy.background) {
            const relatives = document.getElementsByClassName('_backgroundImg');
            for (let relative of relatives) {
              relative.style.backgroundImage = 'url("' + res.data.diy.background + '")';
              relative.style.backgroundSize = 'cover';
            }
          }
          if (res.data.diy.title) {
            currentTitleDiy.value = res.data.diy.title
          }
          if (res.data.diy.content) {
            currentContentDiy.value = res.data.diy.content
          }
          resolve()
        }
      } else {
        reject()
      }
    }).catch(err => {
      reject()
    })
  })
}

// 生命周期函数：组件挂载前执行
onBeforeMount(() => {
  getTenantByWebsiteFun()
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});

// 生命周期函数：组件卸载前执行
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});



// 生命周期函数：组件挂载后执行
onMounted(() => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isDev = process.env.NODE_ENV == 'development'
  console.log(isMobile && !isDev)
  if (isMobile && !isDev) {
    location.reload(true);
  }
  // 默认赋值 缓存语言
  currentLanguage.value = localStorage.getItem('localeLanguage')
});

// 用户名
const touserName = (value) => {
  loginForm.userName = value;
};

// 密码
const toPassword = (value) => {
  loginForm.password = value;
};

// 切换记住我选项
const tabChecked = () => {
  checked.value = !checked.value;
  loginForm.rememberMe = checked.value;
};

// 切换语言
const tabLanguage = (e) => {
  store.dispatch('setLanguage', e);
  localStorage.setItem('localeLanguage', e);

  locale.value = e;
  document.title = i18n.global.t('site.name');
};

// 显示验证码并登录
const toLogin = () => {
  verifyRef.value.show();
};

// 监听userName 如果相同，hasReadTerms 为true

// 注册
// const toSignup = ()=>{
//   router.push({
//     path: '/signup'
//   })
// }

// 处理登录操作
const handleLogin = () => {
  getTenantIdByName(loginForm.tenantName).then(() => {
    login(loginForm).then(res => {

      // 将阅读条款状态存入缓存
      localStorage.setItem(`hasReadTerms_${loginForm.userName}`, "true");

      setToken(res.data.accessToken);
      setRefreshToken(res.data.refreshToken)
      console.log(' = accessToken', res.data, getStoredRefreshToken())
      console.log(' = 用户id', res, res.data)
      if (res && res.data && res.data.userId) {
        const userId = res.data.userId;

        console.log("进入逻辑中，用户 ID:", userId);


        // 确保 window.dataLayer 存在
        window.dataLayer = window.dataLayer || [];

        console.log('typeof gtag', typeof gtag)
        setTimeout(() => {
          if (typeof gtag === "function") {
            gtag('config', 'G-S16NX733BN', { 'user_id': userId });
            console.log("GA4 用户 ID 赋值成功:", userId);
          } else {
            console.warn("gtag 仍未加载，可能 GA4 还没准备好");
          }
        }, 4000); // 延迟 2 秒执行
        if (typeof umami !== 'undefined') {
          umami.identify(userId, {
            username: loginForm.userName,
            loginTime: new Date().toISOString()
          });
          console.log("Umami 用户 ID 追踪成功:", userId);
        } else {
          console.warn("Umami 未加载，用户ID追踪失败");
        }
      }


      router.push({ path: '/dashboard-default' });
    }).catch(() => {
      ElMessage.warning('登录失败');
    });
  });
};

// 检查缓存中的阅读条款状态
const checkReadTerms = () => {
  if (loginForm.userName) {
    const readTerms = localStorage.getItem(`hasReadTerms_${loginForm.userName}`);
    hasReadTerms.value = readTerms === "true";
  } else {
    hasReadTerms.value = false;
  }
};
const currentContentDiy = ref('')
const currentTitleDiy = ref('')
const currentTitle = process.env['VUE_APP_TITLE'] || "site.primaryName"
console.log(' = currentTitle', currentTitle)

// 监听用户名变化，动态检查阅读条款状态
watch(() => loginForm.userName, checkReadTerms);
</script>

<template>
  <div v-loading="allLoading">
    <div class="container top-0 position-sticky z-index-sticky">
      <div class="row">
        <div class="col-12">
          <navbar
            isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
            v-bind:darkMode="true"
            isBtn="bg-gradient-success"
            :currentTitleDiy="currentTitleDiy"
          />
        </div>
      </div>
    </div>
    <Verify
      ref="verifyRef"
      :captchaType="captchaType"
      :imgSize="{ width: '400px', height: '200px' }"
      mode="pop"
      @success="handleLogin"
    />
    <main class="mt-0 main-content">
      <section>
        <div class="page-header min-vh-100">
          <div class="container">
            <div class="row">
              <div
                class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
              >
                <div class="card card-plain">
                  <div class="pb-0 card-header text-start">
                    <h4
                      class="font-weight-bolder _title"
                      v-if="!currentTitleDiy"
                    >
                      {{ $t(currentTitle) }}
                    </h4>
                    <h4
                      class="font-weight-bolder _title"
                      v-if="currentTitleDiy"
                    >
                      {{ currentTitleDiy }}
                    </h4>
                    <p v-if="!currentTitleDiy" class="mb-0">
                      {{ $t("login.welcome") }}{{ $t(currentTitle)
                      }}{{ $t("site.name") }}
                    </p>
                    <p v-if="currentTitleDiy" class="mb-0">
                      {{ $t("login.welcome") }}{{ $t(currentTitleDiy)
                      }}{{ $t("site.name") }}
                    </p>
                  </div>
                  <div class="card-body">
                    <form role="form">
                      <div class="mb-3">
                        <argon-input
                          id="email"
                          placeholder="Email"
                          name="email"
                          size="lg"
                          @update:modelValue="touserName"
                        />
                      </div>
                      <div class="mb-3">
                        <argon-input
                          id="password"
                          type="password"
                          placeholder="Password"
                          name="password"
                          size="lg"
                          @update:modelValue="toPassword"
                        />
                      </div>

                      <div
                        class=""
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                        "
                      >
                        <argon-switch
                          id="rememberMe"
                          name="remember-me"
                          @click="tabChecked"
                          :checked="checked"
                          >{{ $t("login.rememberMe") }}</argon-switch
                        >

                        <!--                      <div class="d-flex align-items-center">-->
                        <!--                        <div class="form-check">-->
                        <!--                          <input-->
                        <!--                              class="form-check-input"-->
                        <!--                              type="checkbox"-->
                        <!--                              v-model="hasReadTerms"-->
                        <!--                          />-->
                        <!--                          <label class="custom-control-label" :class="$attrs.class">-->
                        <!--                            {{$t('login.iAgree')}}-->
                        <!--                            <a href="/terms.html" target="_blank" class="text-dark font-weight-bolder">{{$t('login.userTerms')}}</a>-->
                        <!--                          </label>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                      </div>

                      <div class="text-center">
                        <!--                      <el-button type="success" :disabled="!hasReadTerms" style="width: 100%; padding: 20px 0; margin: 10px 0;" @click="toLogin" class="bg-gradient-success">-->
                        <!--                        {{$t('login.signIn')}}-->
                        <!--                      </el-button>-->

                        <el-button
                          type="success"
                          style="width: 100%; padding: 20px 0; margin: 10px 0"
                          @click="toLogin"
                          class="bg-gradient-success"
                        >
                          {{ $t("login.signIn") }}
                        </el-button>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-end"
                      >
                        <!--                      <el-link type="primary" @click="toSignup">注册</el-link>-->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div
                class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
              >
                <div
                  class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden _backgroundImg"
                  style="
                    /*background-image: url(https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg);*/
                    background-image: url(&quot;/images/signin-right.png&quot;);
                    background-size: cover;
                  "
                >
                  <span class="mask bg-gradient-success opacity-6"></span>
                  <div v-if="currentTitleDiy">
                    <h4
                      class="mt-5 text-white font-weight-bolder position-relative"
                    >
                      {{ currentTitleDiy }}
                    </h4>
                    <div
                      class="mt-5 text-white font-weight-bolder position-relative"
                      v-html="currentContentDiy"
                    ></div>
                  </div>
                  <div v-if="!currentTitleDiy">
                    <h4
                      v-if="currentTitle === 'site.primaryName'"
                      class="mt-5 text-white font-weight-bolder position-relative"
                    >
                      {{ $t("login.company") }}
                    </h4>
                    <h4
                      v-if="currentTitle !== 'site.primaryName'"
                      class="mt-5 text-white font-weight-bolder position-relative"
                    >
                      {{ $t("login.yantaiCompany") }}
                    </h4>

                    <p
                      v-if="currentTitle === 'site.primaryName'"
                      v-html="$t('login.companyProfile')"
                    ></p>
                    <p
                      v-if="currentTitle !== 'site.primaryName'"
                      v-html="$t('login.yantaiCompanyProfile')"
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-select
          v-model="currentLanguage"
          placeholder="Select"
          style="width: 120px; margin-right: 20px"
          class="langage-container"
          @change="tabLanguage"
        >
          <el-option
            v-for="item in languageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </section>
    </main>
  </div>
</template>
<style scoped>
.langage-container {
  position: fixed;
  left: 10px;
  bottom: 10px;
}
</style>
